import { CampaignModel } from '@pukka/api';
import { Dropdown } from '@pukka/ui-components';
import { useSnapshot } from '@pukka/valtio';

import { State, _PersistedState } from './CustomerDisplay.state';

type CampaignStatusSelection = CampaignModel.StatusSelection;

type StatusDropdownValue = {
  key: CampaignStatusSelection;
  value: string;
  meta: {
    key: CampaignStatusSelection;
    value: string;
  };
};

const STATUSES: Record<CampaignStatusSelection, string> = {
  all: 'All Status',
  scheduled: 'Scheduled',
  active: 'Ongoing',
  inactive: 'Inactive',
};

const STATUS_IDS: CampaignStatusSelection[] = ['all', 'scheduled', 'active', 'inactive'];

const options: StatusDropdownValue[] = STATUS_IDS.map((statusId) => ({
  key: statusId,
  value: STATUSES[statusId],
  meta: { key: statusId, value: STATUSES[statusId] },
}));

function handleChange(value: StatusDropdownValue) {
  State.onChangeFilter(value.key);
}

function StatusSelector() {
  const { isFetched } = State.useData();

  const { status } = useSnapshot(_PersistedState);
  const { selectedOutletId, campaigns } = useSnapshot(State);

  const disabled = !isFetched || (!selectedOutletId && status === 'all' && campaigns.size < 1);

  const selected: StatusDropdownValue = {
    key: status,
    value: STATUSES[status],
    meta: {
      key: status,
      value: STATUSES[status],
    },
  };

  return (
    <Dropdown value={selected} disabled={disabled} onChange={handleChange} data-testid="status-selector">
      {options.map((option) => {
        return (
          <Dropdown.Option key={option.key} value={option}>
            {option.value}
          </Dropdown.Option>
        );
      })}
    </Dropdown>
  );
}

export { StatusSelector };
